(function () {
  var SEL = '.additional-checkout-buttons';
  var VERTICAL = 'additional-checkout-buttons--vertical';
  var HORIZONTAL = 'additional-checkout-buttons--horizontal';
  var MIN_ROW_WIDTH = 340; // 3 buttons need ~330px

  function isStacked(el) {
    var k = el.children;
    return k.length > 1 &&
      Math.abs(k[0].getBoundingClientRect().x - k[1].getBoundingClientRect().x) < 2;
  }

  function fix(wrapper) {
    if (!wrapper.clientWidth) return; // still hidden, wait for it to open

    var horizontal = wrapper.clientWidth >= MIN_ROW_WIDTH;
    wrapper.classList.toggle(HORIZONTAL, horizontal);
    wrapper.classList.toggle(VERTICAL, !horizontal);

    var el = wrapper.querySelector(
      'shopify-accelerated-checkout-cart, shopify-accelerated-checkout'
    );
    if (!el || !el.children.length) return;

    // Layout already matches what we want? nothing to do.
    if (horizontal !== isStacked(el)) return;
    if (el.dataset.wlRemount === String(horizontal)) return; // loop guard

    // The component locks its layout at mount time -> remount it.
    var clone = el.cloneNode(true);
    clone.dataset.wlRemount = String(horizontal);
    el.replaceWith(clone);
  }

  function scan() {
    document.querySelectorAll(SEL).forEach(fix);
  }

  function init() {
    var io = new IntersectionObserver(scan);
    function observe() {
      document.querySelectorAll(SEL).forEach(function (w) { io.observe(w); });
    }

    scan();
    observe();

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { observe(); scan(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(scan, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();